<script>
    import {onMount,beforeUpdate} from "svelte";
    import {docs} from "../store";
    let nombre = "Año";
    let tipo = 0;
    let cajasSM = [], cajasC = [], cajasSF = [], cajasG = [];
    let historialSM = [],historialC = [],historialSF = [],historialG = [];
    let dataSM = [],dataC = [],dataSF= [],dataG=[];
    let mes = [
		'Enero','Febrero','Marzo',
		'Abril','Mayo','Junio',
		'Julio','Agosto','Septiembre',
	'Octubre','Noviembre','Diciembre'
    ];
    let labels = [];
    onMount(()=>{
    })
    beforeUpdate(()=>{
        cargarValores();
    })

    function esActual(f){
        let fecha = new Date(f);
        let actual = new Date();
		let actualDia = actual.getDate();
		let actualMes = actual.getMonth() + 1;
		let actualAno = actual.getFullYear();
		let fechaDia = fecha.getDate();
		let fechaMes = fecha.getMonth() + 1;
		let fechaAno = fecha.getFullYear();
		return (actualDia == fechaDia && actualMes == fechaMes && actualAno == fechaAno);
	}
    function cargarValores(){
        let lista = $docs.filter((doc)=>doc._id.includes("caja:"));
        cajasSM = lista.filter((doc)=> doc._id.includes("caja:San Martin")).sort((a,b)=>{
            let fechaA = new Date(a.fecha);
            let fechaB = new Date(b.fecha);
            return fechaA.getTime() - fechaB.getTime();
        });
        cajasC = lista.filter((doc)=> doc._id.includes("caja:Costa")).sort((a,b)=>{
            let fechaA = new Date(a.fecha);
            let fechaB = new Date(b.fecha);
            return fechaA.getTime() - fechaB.getTime();
        });
        cajasSF = lista.filter((doc)=> doc._id.includes("caja:Santa Fe")).sort((a,b)=>{
            let fechaA = new Date(a.fecha);
            let fechaB = new Date(b.fecha);
            return fechaA.getTime() - fechaB.getTime();
        });
        cajasG = lista.filter((doc)=> doc._id.includes("caja:Guemes")).sort((a,b)=>{
            let fechaA = new Date(a.fecha);
            let fechaB = new Date(b.fecha);
            return fechaA.getTime() - fechaB.getTime();
        });
        historialSM = $docs.filter((el)=>{
				return (el._id.includes("registro:") && esActual(el.fecha));
            }).filter((el)=>el.idLocal == "local:San Martin");
        historialC = $docs.filter((el)=>{
				return (el._id.includes("registro:") && esActual(el.fecha));
            }).filter((el)=>el.idLocal == "local:Costa");
        historialSF = $docs.filter((el)=>{
				return (el._id.includes("registro:") && esActual(el.fecha));
            }).filter((el)=>el.idLocal == "local:Santa Fe");
        historialG = $docs.filter((el)=>{
				return (el._id.includes("registro:") && esActual(el.fecha));
            }).filter((el)=>el.idLocal == "local:Guemes");
    }
    
    function datosAmostrar(){
        let stops = {};
        switch(tipo){
            case 0:
                nombre = "Año";
                dataSM = [];
                dataC = [];
                dataSF = [];
                dataG = [];
                labels = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
                stops = {};

                datasets = [
                    {
                        backgroundColor: "rgba(255, 99, 132,0.1)",
                        borderColor: "rgb(255, 99, 132)",
                        data: dataSM
                    },
                    {
                        backgroundColor: "rgba(246, 153, 63,0.1)",
                        borderColor: "rgb(246, 153, 63)",
                        data: dataC
                    },
                    {
                        backgroundColor: "rgba(101, 116, 205,0.1)",
                        borderColor: "rgb(101, 116, 205)",
                        data: dataSF
                    },
                    {
                        backgroundColor: "rgba(101, 205, 116,0.1)",
                        borderColor: "rgb(101, 205, 116)",
                        data: dataG
                    }
			    ]
                break;
            case 1:
                nombre = "Mes";
                dataSM = [];
                dataC = [];
                dataSF = [];
                dataG = [];
                labels = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
                stops = {};

                datasets = [
                    {
                        backgroundColor: "rgba(255, 99, 132,0.1)",
                        borderColor: "rgb(255, 99, 132)",
                        data: dataSM
                    },
                    {
                        backgroundColor: "rgba(246, 153, 63,0.1)",
                        borderColor: "rgb(246, 153, 63)",
                        data: dataC
                    },
                    {
                        backgroundColor: "rgba(101, 116, 205,0.1)",
                        borderColor: "rgb(101, 116, 205)",
                        data: dataSF
                    },
                    {
                        backgroundColor: "rgba(101, 205, 116,0.1)",
                        borderColor: "rgb(101, 205, 116)",
                        data: dataG
                    }
			    ]
                break;
            case 2:
                nombre="Semana";
                dataSM = [];
                dataC = [];
                dataSF = [];
                dataG = [];
                labels = [];
                stops = {};

                break;
            case 3:
                nombre="Día";
                dataSM = [];
                dataC = [];
                dataSF = [];
                dataG = [];
                labels = [];
                stops = {};
                historialSM.forEach((el)=>{

                })
                historialSF.forEach((el)=>{
                    
                })
                historialC.forEach((el)=>{
                    
                })
                historialG.forEach((el)=>{
                    
                })
                break;
        }
    }
    function cambiar(){

    }

</script>
<div class="w-full flex flex-col items-center justify-start sm:flex-row sm:items-start">
    <div class="relative bg-white w-full my-2 rounded shadow flex flex-col sm:w-1/2">
        <div class="absolute top-8 left-2 text-xs">Valor en Pesos</div>
        <div class="w-full flex items-center justify-between">
            <h1 class="text-xl font-bold m-2">Comparación locales</h1>	
        </div>
        <div class="flex w-full items-center justify-center text-xs">
            <p class="text-red-400 font-bold text-xs w-full flex items-center justify-center">San Martin</p>
            <p class="text-blue-400 font-bold text-xs w-full flex items-center justify-center">Costa</p>
            <p class="text-yellow-400 font-bold text-xs w-full flex items-center justify-center">Santa Fe</p>
            <p class="text-green-400 font-bold text-xs w-full flex items-center justify-center">Güemes</p>
        </div>
        <div class="w-full relative h-350-px">
            <canvas id="todos" />
        </div>
        <div class="w-full flex items-center justify-end p-2">
            <button class="m-2 p-2 bg-red-500 text-white rounded shadow" on:click={cambiar}>{nombre}</button>
        </div>
    </div>
    <div class="w-full flex flex-col items-center justify-between sm:w-1/2">
        <h1 class="w-full flex items-center justify-center font-bold">Alertas de stock</h1>
    </div>	
</div>